export default __webpack_public_path__ + "static/media/planty-min.8d8f3573.png";